import { lazy } from 'react';
import { Outlet } from 'react-router';
import { HomeIcon } from '@hf/designSystem/v1';
import type { SpaDefinition } from '@core/routes';

const HomePage = lazy(async () => {
  const mod = await import('./pages/HomePage');
  return { default: mod.HomePage };
});

function SpaOutlet() {
  return <Outlet />;
}

export const homeSpa = {
  key: 'home',
  path: '/',
  label: 'Home',
  icon: <HomeIcon />,
  public: false,
  nav: 'main',
  paths: {},
  layout: <SpaOutlet />,
  children: [{ index: true, element: <HomePage /> }],
} as const satisfies SpaDefinition;
